module.exports = __webpack_public_path__ + "img/logo-komerce-no-tag.14a98833.png";